"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOURS_MAP = void 0;
exports.HOURS_MAP = {
    WORK: 'Werkuren',
    TRAVEL: 'Reisuren',
    SPECIAL: 'Niet gewerkt',
    TOTAL: 'Totaal',
    WORKER: 'Medewerker',
    VIEW: 'Bekijk medewerker',
    APPROVE: 'Keur goed',
    CONTROL: 'Controleren',
    START_TIME: 'tijdstip ingevoerd',
    WORK_START_TIME: 'opgegeven tijd',
};
